<div class="clearfix">
  <h3 class="h3">Chat</h3>
  <div class="content">
    <div class="chat_content">
      <div class="chat_list">
        <h3 class="h3 m-0">{{activeUrl?"Client List":"TPA List"}}</h3>
        <div class="search">
          <form action="#" class="fc_form ng-untouched ng-pristine ng-valid">
            <div class="form-group">
              <input type="search" placeholder="Search" class="form-control ng-pristine ng-valid ng-touched"
                [(ngModel)]="searchInput" name="search" />
              </div>
            </form>
          </div>

          <div class="list-item">
            <ul>
              @for (thread of searchThread(); track thread) {
                <li class="chat-details-list" (click)="updateThread(thread)"
                  [class.active]="thread.id == currentThread?.id">
                  <div class="details d-flex justify-content-between align-items-center">
                    <div class="details-div d-flex">
                      <div class="profile-pic">
                        <span class="profile-image">{{
                        activeUrl?getName(thread.topic.split(",")[0]):getName(thread.topic.split(",")[1]) }}</span>
                      </div>
                      <div class="profile-details">
                        <p class="text-capitalize m-0">{{ activeUrl?thread.topic.split(",")[0]:thread.topic.split(",")[1] }}
                        </p>
                        <p class="date">{{ getConvertedDate(thread.lastMessageReceivedOn) }}</p>
                      </div>
                    </div>
                    <div class="deletee-icon">
                      <div class="dropdown dropdown-menu-end box_dropdown" ngbDropdown>
                        <button type="button" id="docDropDown" placement="left-bottom" ngbDropdownToggle type="button"
                          class="info_btnn dropdown-toggle" data-bs-toggle="dropdown" aria-label="Options button">
                          <img src="/assets/images/more-vertical.svg" alt="" />
                        </button>
                        <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="docDropDown">
                          <li>
                            <a class="dropdown-item" (click)="deleteChatThread(thread.id)"><span class="options-icon"><img
                            src="/assets/images/delete-icon.svg" alt="delete icon" class="del-icon" /></span>
                          Delete</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            }

          </ul>
        </div>
      </div>
    </div>
    <div class="chat_content">
      <!--Chat Tab Starts Here-->
      <div class="chat_details">
        <div class="chat-tab">
          <div class="chat-header d-flex justify-content-between mb-2">
            <div class="users-names d-flex g-3">
              <p class="text-capitalize m-0">
              {{activeUrl?currentThread?.topic.split(",")[0]:currentThread?.topic.split(",")[1]}}</p>
            </div>
          </div>
          <div class="chat-wrapper">
            <div class="chatting">
              <div class="chat-history">
                <ul>
                  @for (message of messages; track message) {
                    <li class="clearfix">
                      @if (message?.sender.communicationUserId == userService?.userInfo?.acsIdentity) {
                        <div
                          >
                          <!--Messages Right Starts Here-->
                          <div class="message-data d-flex gap-3 justify-content-end align-items-center">
                            <div class="profile-name d-flex justify-content-end align-items-baseline">
                              <span class="message-data-time m-0">
                                {{
                                message.createdOn | date
                              }}</span>
                            </div>
                          </div>
                          <div class="msg d-flex justify-content-end">
                            <div class="message other-message user-msg d-flex">
                              {{ message.content.message }}
                              <div class="delete-icon">
                                <div class="dropdown dropdown-menu-end box_dropdown" ngbDropdown>
                                  <button type="button" id="docDropDown" placement="left-bottom" ngbDropdownToggle
                                    type="button" class="info_btn dropdown-toggle" data-bs-toggle="dropdown"
                                    aria-label="Options button">
                                    <img src="/assets/images/more-vertical.svg" alt="" />
                                  </button>
                                  <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="docDropDown">
                                    <li>
                                      <a class="dropdown-item" (click)="deleteMessage(message.id)"><span
                                        class="options-icon">
                                        <img class="del-icon" src="/assets/images/delete-icon.svg"
                                        alt="delete icon" /></span>
                                      Delete</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      } @else {
                        <div class="wrapper d-flex gap-3 align-items-end">
                          <div class="msg-wrapper">
                            <div class="message-data d-flex align-items-center gap-3">
                              <div class="profile-name d-flex gap-1 align-items-baseline">
                                <span class="message-data-time m-0">
                                  {{
                                  message.createdOn | date
                                }}</span>
                              </div>
                            </div>
                            <div class="message my-message">
                              {{ message?.content.message }}
                            </div>
                          </div>
                        </div>
                      }
                      <!--Messgaes Right Ends Here-->
                    </li>
                  }
                </ul>
              </div>

              <div class="chat-message clearfix d-flex align-items-center justify-content-between mt-5">
                @if (typingMessage) {
                  <i>
                    <div class="message-data">
                      <span class="message-data-name">{{ typingMessage }}</span>
                    </div>
                  </i>
                }
                <input name="message-to-send" id="message-to-send" placeholder="Type your message" rows="3"
                  (keyup)="sendTypingNotification()" (keydown.enter)="sendMessage(); $event.preventDefault()"
                  [(ngModel)]="message" />

                  <button class="send-msg-btn" (click)="sendMessage()" [disabled]="!message.trim()">
                    <img src="../../../assets/images/send-icon.svg" alt="send-icon" width="25" height="25" />
                  </button>
                </div>
              </div>

              <div class="general-info d-none">
                <div class="questions_faq">
                  <div class="questions_accordions">
                    <div class="faq-accordion" id="accountAccordion">
                      <div class="card">
                        <div class="card-header mt-3">
                          <a class="collapsed btn" data-bs-toggle="collapse" href="#details">
                            General Info
                          </a>
                        </div>
                        <div id="details" data-bs-parent="#accountAccordion" class="collapse mb-2">
                          <div class="card-body lp_p">
                            <span class="user_profile">Rs</span>&nbsp;
                            <span class="fw_bold">Rohit Sharma</span>
                            <p class="fw_bold mt-3 mb-0">Email</p>
                            <p class="m-0">xyz&#64;yopmail.com</p>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header mt-3">
                          <a class="collapsed btn" data-bs-toggle="collapse" href="#todo">
                            To-Do List
                          </a>
                        </div>
                        <div id="todo" data-bs-parent="#accountAccordion" class="collapse mb-2">
                          <div class="card-body lp_p">
                            <ul>
                              <li>Add A notes</li>
                              <li>Schedule A Meeting</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header mt-3">
                          <a class="collapsed btn" data-bs-toggle="collapse" href="#appointment">
                            Appointment
                          </a>
                        </div>
                        <div id="appointment" data-bs-parent="#accountAccordion" class="collapse mb-2">
                          <div class="card-body lp_p">
                            <ul>
                              <li>Appointment with advisor</li>
                              <li>Appointment with advisor</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header mt-3">
                          <a class="collapsed btn" data-bs-toggle="collapse" href="#subscription">
                            subscription
                          </a>
                        </div>
                        <div id="subscription" data-bs-parent="#accountAccordion" class="collapse mb-2">
                          <div class="card-body lp_p">
                            <ul>
                              <li>Yearly Plan</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
    <!-- end container -->
  </div>
